module.exports = "/images/18K-2T.webp?987b805dcdb0adad7092aee1a76d60dd";